<template>
  <Container background-color="#F5F7FA" :bounds-inner-styles="containerStyles">
    <h2 class="scout-customers-title">
      <CountUp style="color: #4440db" :target="168"></CountUp>
      <!-- key hires matched with <span style="color: #4440db;">100+</span> happy customers -->
      key hires and counting...
    </h2>

    <img class="scout-customers-pattern" src="@/assets/pages/scout/middle_small_grey_pattern.svg" />
    <div v-if="canScrollLeft" @click="scrollLeft" class="scout-customers-arrow_wrapper_left">
      <img class="scout-customers-arrow" src="@/assets/pages/scout/arrow_right.svg" />
    </div>
    <div v-if="canScrollRight" class="scout-customers-arrow_wrapper_right" @click="scrollRight">
      <img class="scout-customers-arrow" src="@/assets/pages/scout/arrow_right.svg" />
    </div>
    <b-row class="scout-customers-items" ref="cardContainer">
      <div v-for="customer in customers" :key="customer.id" class="scout-customers-customer">
        <img class="scout-customers-customer_img" :src="customer.img" />
        <div class="scout-customers-customer_body">
          <div class="scout-customers-customer_slogan">
            <span style="color:#4440DB;">{{ customer.rolesCount }}</span>
            {{ customer.slogan }}
            <a :href="`/startups/${customer.key}`">{{ customer.title }}</a>
          </div>
          <div class="scout-customers-customer_details_title">Company details:</div>
          <div class="scout-customers-customer_details">
            <div
              v-for="detail in customer.details"
              :key="detail.id"
              class="scout-customers-customer_details-detail"
            >
              {{ detail.content }}
            </div>
          </div>
          <div class="scout-customers-customer_positions_title">
            <!-- Spent {{ customer.spent }} to fill {{ customer.rolesCount }} with
            <a :href="`${customer.hiresWithUrl}`">{{ customer.hiresWith }}</a> -->
            Roles filled:
          </div>
          <div class="scout-customers-customer_positions">
            <div
              v-for="position in customer.positions"
              :key="position.id"
              class="scout-customers-customer_positions-position"
            >
              {{ position.title }}
            </div>
          </div>
          <button class="scout-customers-btn" @click="handleHiringLikeClick(customer.hiresWithUrl)">
            <span>Start hiring like {{ customer.title }}</span>
          </button>
        </div>
      </div>
    </b-row>
  </Container>
</template>

<script>
import Container from '@/components/Container';
import CountUp from './CountUp.vue';

export default {
  name: 'ScoutCusomers',
  components: {
    Container,
    CountUp
  },
  props: {
    startHiring: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      canScrollLeft: false,
      canScrollRight: false,
      customers: [
        {
          id: '5f89828ed7b64b1c8a94e9ac',
          img: require('@/assets/pages/scout/glint_solar_team.webp'),
          title: 'Glint Solar',
          key: 'glint-solar',
          // slogan: 'Accelerating solar energy with ',
          slogan: 'Successful hires made for',
          description: '',
          details: [
            { id: 'gs_dt_0', content: '€8M Series A' },
            { id: 'gs_dt_1', content: 'Oslo, Norway' },
            { id: 'gs_dt_2', content: 'Onsite' },
            { id: 'gs_dt_3', content: 'Climate tech' },
            { id: 'gs_dt_4', content: '50+ Employees' }
          ],
          spent: '€15,400',
          rolesCount: 6,
          hiresWith: 'Scout',
          positions: [
            { id: 'gs_p_0', title: '3 Customer Success Managers ' },
            { id: 'gs_p_1', title: '2 Account Executives' },
            { id: 'gs_p_2', title: '1 Financial Controller' }
          ],
          hiresWithUrl: '/scout'
        },
        {
          id: '6061be94c5b717064c2133dc',
          img: require('@/assets/pages/scout/legacy_team.webp'),
          title: 'Legacy',
          key: 'legacy',
          // slogan: 'Automating carbon accounting with ',
          slogan: 'Successful hires made for',
          description: '',
          details: [
            { id: 'l_dt_0', content: '$2M Seed' },
            { id: 'l_dt_1', content: 'Copenhagen, Denmark' },
            { id: 'l_dt_2', content: 'Hybrid' },
            { id: 'l_dt_3', content: 'SaaS' },
            { id: 'l_dt_4', content: '20+ Employees' }
          ],
          spent: '€6300',
          rolesCount: 3,
          hiresWith: 'Scout',
          positions: [
            { id: 'l_p_0', title: '1 Senior Full-stack Developer' },
            { id: 'l_p_1', title: '1 Frontend Developer' },
            { id: 'l_p_2', title: '1 Jr. Business Associate' }
          ],
          hiresWithUrl: '/scout'
        },
        {
          id: '5b0569615f6519816f9bad69',
          img: require('@/assets/pages/scout/monthio_team.webp'),
          title: 'Monthio',
          key: 'monthio',
          slogan: 'Successful hires made for',
          description: '',
          details: [
            { id: 'm_dt_0', content: '€11.4M Series A' },
            { id: 'm_dt_1', content: 'Copenhagen, Denmark' },
            { id: 'm_dt_2', content: 'Onsite' },
            { id: 'm_dt_3', content: 'Fintech' },
            { id: 'm_dt_4', content: '100+ Employees' }
          ],
          spent: '€6300',
          rolesCount: 5,
          hiresWith: 'Scout',
          positions: [
            { id: 'm_p_0', title: '1 Algorithm Developer' },
            { id: 'm_p_1', title: '2 Senior Data Engineers' },
            { id: 'm_p_2', title: '1 DevOps Engineer' },
            { id: 'm_p_3', title: '1 Full-stack Developer' }
          ],
          hiresWithUrl: '/scout'
        },
        {
          id: '6549130cd1f106fe43fdc14b',
          img: require('@/assets/pages/scout/humly_team.webp'),
          title: 'Humly',
          key: 'humly',
          slogan: 'Successful hires made for',
          description: '',
          details: [
            { id: 'h_dt_0', content: 'Series A' },
            { id: 'h_dt_1', content: 'Gothenburg, Sweden' },
            { id: 'h_dt_2', content: 'Onsite' },
            { id: 'h_dt_3', content: 'Edtech' },
            { id: 'h_dt_4', content: '200+ Employees' }
          ],
          spent: '€6300',
          rolesCount: 3,
          hiresWith: 'Scout',
          positions: [
            { id: 'h_p_0', title: '1 Senior Backend Developer' },
            { id: 'h_p_1', title: '1 Backend Developer' },
            { id: 'h_p_2', title: '1 Frontend Developer' }
          ],
          hiresWithUrl: '/scout'
        },
        {
          id: '5ee207cc61ad985c418205d9',
          img: require('@/assets/pages/scout/doublepoint_team.webp'),
          title: 'Doublepoint',
          key: 'doublepoint',
          slogan: 'Successful hires made for',
          description: '',
          details: [
            { id: 'd_dt_0', content: '€3M Seed' },
            { id: 'd_dt_1', content: 'Helsinki, Finland' },
            { id: 'd_dt_2', content: 'Onsite' },
            { id: 'd_dt_3', content: 'AI / Wearables' },
            { id: 'd_dt_4', content: '20+ Employees' }
          ],
          spent: '€6300',
          rolesCount: 2,
          hiresWith: 'Scout',
          positions: [
            { id: 'd_p_0', title: '1 Senior Full-stack Developer' },
            { id: 'd_p_1', title: '1 Frontend Developer' }
          ],
          hiresWithUrl: '/scout'
        },
        {
          id: '585fd3dcce36ee2935297053',
          img: require('@/assets/pages/scout/superb_team.webp'),
          title: 'Superb',
          key: 'superb',
          slogan: 'Successful hires made for',
          description: '',
          details: [
            { id: 's_dt_0', content: '€12M Series A' },
            { id: 's_dt_1', content: 'Aarhus, Denmark' },
            { id: 's_dt_2', content: 'Hybrid' },
            { id: 's_dt_3', content: 'SaaS' },
            { id: 's_dt_4', content: '100+ Employees' }
          ],
          spent: '€6300',
          rolesCount: 2,
          hiresWith: 'Scout',
          positions: [
            { id: 's_p_0', title: '1 Business Development Manager (Aarhus)' },
            { id: 's_p_1', title: '1 Business Development Manager (Oslo)' }
          ],
          hiresWithUrl: '/scout'
        }
      ]
    };
  },
  mounted() {
    this.updateScrollButtons();
    this.resizeObserver = new ResizeObserver(() => {
      this.updateScrollButtons();
    });
    this.resizeObserver.observe(this.$refs.cardContainer);
    this.$refs.cardContainer.addEventListener('scroll', this.updateScrollButtons);
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.$refs.cardContainer) {
      this.$refs.cardContainer.removeEventListener('scroll', this.updateScrollButtons);
    }
  },
  methods: {
    handleHiringLikeClick() {
      this.startHiring();
    },
    scrollLeft() {
      if (this.$refs.cardContainer) {
        const scrollDistance = this.visibleCards * this.cardWidth;
        this.$refs.cardContainer.scrollBy({
          left: -scrollDistance,
          behavior: 'smooth'
        });
        setTimeout(this.updateScrollButtons, 300);
      }
    },
    scrollRight() {
      if (this.$refs.cardContainer) {
        const scrollDistance = this.visibleCards * this.cardWidth;
        this.$refs.cardContainer.scrollBy({
          left: scrollDistance,
          behavior: 'smooth'
        });
        setTimeout(this.updateScrollButtons, 300);
      }
    },
    updateScrollButtons() {
      if (this.$refs.cardContainer) {
        const { scrollLeft, scrollWidth, offsetWidth } = this.$refs.cardContainer;
        this.canScrollLeft = scrollLeft > 0;
        this.canScrollRight = scrollLeft + offsetWidth < scrollWidth;
      }
    }
  },
  computed: {
    containerStyles() {
      return {
        'padding-top': `${2}rem`,
        'padding-bottom': `${4.5}rem`
      };
    },
    cardWidth() {
      return 413;
    },
    visibleCards() {
      if (this.$refs.cardContainer) {
        const containerWidth = this.$refs.cardContainer.offsetWidth;
        return Math.floor(containerWidth / this.cardWidth);
      }
      return 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.scout {
  a {
    color: #4440db;
  }
}

.scout-customers-title {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  width: 70%;
  @include media-breakpoint-down(md) {
    width: 100%;
  }
}

.scout-customers-pattern {
  position: absolute;
  left: 47.3rem;
  margin-top: 16rem;
  z-index: 1;
  @include media-breakpoint-down(md) {
    left: 18.3rem;
  }
  @include media-breakpoint-down(sm) {
    display: none;
  }
}

.scout-customers-arrow_wrapper_left {
  transform: scaleX(-1);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 4rem;
  width: 4rem;
  position: absolute;
  left: 30px;
  margin-top: 20rem;
  z-index: 3;
  background-color: #4440db;
  cursor: pointer;
  user-select: none;
}

.scout-customers-arrow_wrapper_right {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 4rem;
  width: 4rem;
  position: absolute;
  right: 30px;
  margin-top: 20rem;
  z-index: 3;
  background-color: #4440db;
  cursor: pointer;
  user-select: none;
}

.scout-customers-arrow {
  height: 3.5rem;
  width: 3.5rem;
  user-select: none;
}

.scout-customers-items {
  z-index: 2;
  position: relative;
  margin: 0px;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;
}

.scout-customers-customer {
  background-color: white;
  min-width: rem(400px);
  max-width: rem(400px);
  padding: 0.8rem;
  margin-right: 1.4rem;
  &:last-child {
    margin-right: 0px;
  }
}

.scout-customers-customer_img {
  width: 100%;
  margin-bottom: 1.5rem;
}

.scout-customers-customer_body {
  padding-bottom: 2rem;
  padding: 0 1.5rem 3rem 1.5rem;
}

.scout-customers-customer_slogan {
  font-size: rem(32px);
  font-weight: 500;
  margin-bottom: 1.5rem;
  line-height: 1.3;
}

.scout-customers-customer_details_title {
  font-size: rem(14px);
  font-weight: 500;
  margin-bottom: 0.5rem;
}

.scout-customers-customer_details {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.scout-customers-customer_details-detail {
  font-size: 0.9rem;
  // font-size: rem(16px);
  padding: 0.2rem 0.5rem;
  border: 1px solid #4440db;
  margin-right: 0.8rem;
  margin-bottom: 0.8rem;
}

.scout-customers-customer_positions_title {
  font-size: rem(14px);
  font-weight: 500;
  margin-bottom: 0.5rem;
}

.scout-customers-customer_positions {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.scout-customers-customer_positions-position {
  font-size: 0.8rem;
  padding: 0.2rem 0.5rem;
  color: #4440db;
  background-color: #dbf0fa;
  margin-right: 0.8rem;
  margin-bottom: 0.8rem;
}

.scout-customers-buttons {
  margin: 2rem 0 0 0;
}

.scout-customers-btn {
}

.scout-customers-customer_wrapper {
  display: block;
}

.scout-customers-point_logo {
  height: 45px;
}

.scout-customers-point_title {
  font-weight: bold;
  font-size: large;
  margin-top: 1.5rem;
}

.scout-customers-point_description {
  margin-top: 1rem;
  width: 80%;
}

.scout-customers-buttons {
  margin-top: 3rem;
}

.scout-customers-btn {
  background-color: #4440db;
  color: white;
  height: 4rem;
  width: 17.625rem;
  font-weight: bold;
}
</style>
